import { Dispatch, useContext } from 'react';
import { EStaticHostingAction } from '../stores/action';
import { StaticHostingDispatchContext } from '../stores/provider';
const useCodePipelineDispatch = (): Dispatch<EStaticHostingAction<any>> => {
  return useContext(StaticHostingDispatchContext) as Dispatch<EStaticHostingAction<any>>;
};
export default useCodePipelineDispatch;
